import { Button, ButtonProps, Tooltip, useAudio } from "@aircall/tractor";
import styled from "@xstyled/styled-components";
import { PropsWithChildren, ReactNode } from "react";
import { DELAY } from "@/constants/tooltip.constants";

const CustomButton = styled(Button)`
  & svg path {
    fill: secondary;
  }
  &:disabled svg path {
    fill: icon-disabled;
  }
`;

export function SkipButton({
  children,
  onClick,
  backward,
  tooltipContent,
  ...rest
}: PropsWithChildren<ButtonProps> & {
  backward?: boolean;
  tooltipContent: ReactNode;
}) {
  const { fastForward, rewind } = useAudio();

  const handleOnClick: ButtonProps["onClick"] = (event) => {
    if (backward) {
      rewind();
    } else {
      fastForward();
    }

    onClick?.(event);
  };

  return (
    <Tooltip mouseEnterDelay={DELAY} content={tooltipContent}>
      <CustomButton
        variant="secondary"
        size="small"
        mode="ghost"
        onClick={handleOnClick}
        {...rest}
      >
        {children}
      </CustomButton>
    </Tooltip>
  );
}
